module.exports = __webpack_public_path__ + "static/media/Icon-ExternalTransfer.2eba69a3.png";